
export enum AlertRuleStatus {
    Active,
    Deleted,
    Paused
}
